import { render, staticRenderFns } from "./OverviewRootBlockToolbar.vue?vue&type=template&id=bbc54458&scoped=true"
import script from "./OverviewRootBlockToolbar.vue?vue&type=script&lang=js"
export * from "./OverviewRootBlockToolbar.vue?vue&type=script&lang=js"
import style0 from "./OverviewRootBlockToolbar.vue?vue&type=style&index=0&id=bbc54458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc54458",
  null
  
)

export default component.exports